/* Gestion du menu */

import { isMobile } from './utilities'

// Au chargement de la page
window.addEventListener('load', function () {
  isMobile();
});

const menuItemsHasChildren = document.querySelectorAll('.footer-navigation .menu-item-has-children > a');

if (menuItemsHasChildren && (window.innerWidth < 1020)) {
  for (var i = 0; i < menuItemsHasChildren.length; i++) {
    menuItemsHasChildren[i].addEventListener('click', function (event) {
      event.preventDefault();
      this.parentNode.classList.toggle('is-open-submenu');
      this.querySelector('.icon-chevron').classList.toggle('icon-chevron-rotate');
      hideAll(this);
    });
  }
}

function hideAll(exceptThis) {
  for (var i = 0; i < menuItemsHasChildren.length; i++) {
    if (menuItemsHasChildren[i] !== exceptThis) {
      menuItemsHasChildren[i].parentNode.classList.remove('is-open-submenu');
      menuItemsHasChildren[i].querySelector('.icon-chevron').classList.remove('icon-chevron-rotate');
    }
  }
}

// A chaque resize du nagigateur
window.addEventListener('resize', function () {
  isMobile();
});